import { Space, Tag, Typography } from 'antd';
import { Link } from 'react-router-dom';
import { ROUTES } from '@/constants/routes';
import type { OrderIssuedEInvoice } from '@/mocks/orders';

const { Text } = Typography;

/** Hoá đơn gốc không cần nhãn; chỉ đánh dấu hoá đơn phát sinh sau để phân biệt khi đơn có nhiều số. */
const REFERENCE_TYPE_LABEL: Record<string, string> = {
  replacement: 'Thay thế',
  adjustment: 'Điều chỉnh',
};

/**
 * TCR-1967/1968 — cột "Số hoá đơn" trên danh sách Đơn hàng và Đơn Ecom.
 *
 * Liệt kê TẤT CẢ hoá đơn GTGT đã phát hành của đơn (một đơn có thể có hoá đơn gốc + thay thế/điều
 * chỉnh). Mỗi số là link sang chi tiết hoá đơn ở màn Hoá đơn GTGT. Chưa phát hành → "—".
 */
export function EInvoiceNumbersCell({ invoices }: { invoices?: OrderIssuedEInvoice[] | null }) {
  if (!invoices || invoices.length === 0) return <Text type="secondary">—</Text>;

  return (
    <Space direction="vertical" size={2}>
      {invoices.map((invoice) => {
        const refLabel = invoice.reference_type ? REFERENCE_TYPE_LABEL[invoice.reference_type] : undefined;
        return (
          <Space key={invoice.id} size={4} wrap={false}>
            <Link
              to={`${ROUTES.accounting.accountingEInvoices}/${invoice.id}`}
              // Dòng bảng có thể bắt click để mở đơn — bấm số hoá đơn chỉ được mở hoá đơn.
              onClick={(event) => event.stopPropagation()}
              data-testid="order-e-invoice-link"
            >
              {invoice.invoice_number || '(chưa có số)'}
            </Link>
            {refLabel && <Tag style={{ marginInlineEnd: 0 }}>{refLabel}</Tag>}
          </Space>
        );
      })}
    </Space>
  );
}
